export const getBoardUrl = (projectKey: string, boardId: string) =>
	`/jira/software/c/projects/${projectKey}/boards/${boardId}`;
